<vp-header
	[editableInStoryblok]="_editable()"
	[hideMenu]="hideMenu()"
	[menuItems]="headerMenu()"
	[metaMenu]="metaMenu()"
	[title]="hotelStore.slug() || title()"
	(languageSwitch)="onLanguageSwitch($event)"
/>
